import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";
import AuthRecoveryRedirect from "@/components/auth/AuthRecoveryRedirect";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Home from "./pages/Home";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

// Páginas institucionais
import Precos from "./pages/Precos";
import Empresas from "./pages/Empresas";
import Suporte from "./pages/Suporte";
import FAQ from "./pages/FAQ";
import TermosUso from "./pages/TermosUso";
import Privacidade from "./pages/Privacidade";

// Blog Posts
import TecnicasProcrastinar from "./pages/posts/TecnicasProcrastinar";
import CienciaHabitos from "./pages/posts/CienciaHabitos";
import MeditacaoMudouMinhaVida from "./pages/posts/MeditacaoMudouMinhaVida";
import HabitoExercicios from "./pages/posts/HabitoExercicios";
import Leia52LivrosPorAno from "./pages/posts/Leia52LivrosPorAno";
import RotinaNortuna from "./pages/posts/RotinaNortuna";
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <AuthRecoveryRedirect />
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/app" element={<Index />} />
            <Route path="/home" element={<Home />} />
            
            {/* Páginas institucionais */}
            <Route path="/precos" element={<Precos />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/suporte" element={<Suporte />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/termos-uso" element={<TermosUso />} />
            <Route path="/privacidade" element={<Privacidade />} />
            
            {/* Blog Posts */}
            <Route path="/blog/5-tecnicas-para-nunca-mais-procrastinar" element={<TecnicasProcrastinar />} />
            <Route path="/blog/ciencia-formacao-habitos" element={<CienciaHabitos />} />
            <Route path="/blog/como-a-meditacao-diaria-mudou-minha-vida" element={<MeditacaoMudouMinhaVida />} />
            <Route path="/blog/como-criar-o-habito-de-exercicios" element={<HabitoExercicios />} />
            <Route path="/blog/leia-52-livros-por-ano" element={<Leia52LivrosPorAno />} />
            <Route path="/blog/rotina-noturna-para-dormir-melhor" element={<RotinaNortuna />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
